/**
 * @file Skins : achat (argent ou gemmes), equipement (visuel), attribution gratuite ; bonus permanents via stats/sources.skinSource.
 */
import { fail, okVoid } from '@shared/types';
import type { Result } from '@shared/types';
import type { SimContext } from '../Context';

export class SkinService {
  constructor(private readonly ctx: SimContext) {}

  owns(id: string): boolean {
    return this.ctx.data.skins.owned.includes(id);
  }

  /** Achat d'un skin du catalogue ; ses bonus s'appliquent des l'achat (equipe ou non). */
  buy(id: string): Result {
    const ctx = this.ctx;
    const skin = ctx.config.skins.find((s) => s.id === id);
    if (!skin) return fail('unknownId');
    if (this.owns(id)) return fail('alreadyOwned');
    if (!ctx.services.unlocks.isFeatureUnlocked('skins')) return fail('locked');
    return ctx.tx.purchase(skin.cost, `skin:${id}`, () => {
      ctx.data.skins.owned.push(id);
      ctx.bus.emit('SkinBought', { id });
      ctx.bus.emit('ModifiersDirty', { source: `skin:${id}` });
      return okVoid;
    });
  }

  /** Equipe un skin possede (visuel seulement) et met a jour les chats vivants. */
  equip(id: string): Result {
    const ctx = this.ctx;
    if (!this.owns(id)) return fail('notOwned');
    ctx.data.skins.equipped = id;
    for (const e of ctx.rt.world.ofKind('cat')) if (e.cat) e.cat.skinId = id;
    ctx.bus.emit('SkinEquipped', { id });
    return okVoid;
  }

  /** Ajout gratuit (recompense). */
  grant(id: string): void {
    const ctx = this.ctx;
    if (this.owns(id) || !ctx.config.skins.some((s) => s.id === id)) return;
    ctx.data.skins.owned.push(id);
    ctx.bus.emit('SkinBought', { id });
    ctx.bus.emit('ModifiersDirty', { source: `skin:${id}` });
  }
}
